import React, { useState } from 'react';
import { Search, Zap, Brain, Sparkles } from 'lucide-react';
import { useAgentStore } from '@/stores/agentStore';

export type SearchMode = 'auto' | 'fast' | 'deep';

export const SearchModeSelector: React.FC = () => {
  const { searchMode, setSearchMode } = useAgentStore();
  const [isOpen, setIsOpen] = useState(false);

  const modes = [
    { id: 'auto' as SearchMode, label: 'Auto', icon: Sparkles, description: '智能选择', color: 'text-cyan-400' },
    { id: 'fast' as SearchMode, label: '快速', icon: Zap, description: '实时搜索', color: 'text-blue-400' },
    { id: 'deep' as SearchMode, label: '深度', icon: Brain, description: '深度分析', color: 'text-purple-400' },
  ];

  const currentMode = modes.find(m => m.id === searchMode) || modes[0];
  const CurrentIcon = currentMode.icon;

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className={`flex items-center gap-1.5 px-2.5 py-1 text-xs ${currentMode.color} bg-white/5 hover:bg-white/10 rounded-md transition-colors`}
        title="搜索模式"
      >
        <Search size={12} />
        <span>{currentMode.label}</span>
        <CurrentIcon size={12} />
      </button>

      {isOpen && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
          <div className="absolute bottom-full left-0 mb-1 w-44 bg-[#1e1e2e] border border-white/10 rounded-lg shadow-xl z-50 py-1">
            <div className="px-3 py-1.5 text-[10px] text-gray-500 border-b border-white/5">
              搜索模式
            </div>
            {modes.map((mode) => {
              const ModeIcon = mode.icon;
              return (
                <button
                  key={mode.id}
                  onClick={() => {
                    setSearchMode(mode.id);
                    setIsOpen(false);
                  }}
                  className={`w-full text-left px-3 py-2 transition-colors ${
                    searchMode === mode.id
                      ? `${mode.color} bg-white/10`
                      : 'text-gray-400 hover:text-white hover:bg-white/5'
                  }`}
                >
                  <div className="flex items-center gap-2">
                    <ModeIcon size={14} />
                    <div>
                      <div className="font-medium text-xs">{mode.label}</div>
                      <div className="text-[10px] text-gray-500">{mode.description}</div>
                    </div>
                  </div>
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
};
